import detectDeviceOrientation from 'src/js/modules/utils/detect-device-orientation';
import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

const trackApiRateExceededEvent = () => {
  trackEvent(events.ERROR_CAUGHT, {
    errorMessage: 'The API rate for Unsplash integration is exceeded',
    deviceOrientation: detectDeviceOrientation(),
  });
};

export default trackApiRateExceededEvent;
